import dayjs from "./dayjs";

export const convertToUtc = (val) => {
  return val ? new Date(val).toISOString() : "";
};

export const combineUtcDateTime = (date, time) => {
  const d = dayjs.utc(date);
  const t = dayjs.utc(time);

  return d.hour(t.hour()).minute(t.minute()).second(t.second()).millisecond(0);
};

export const getTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

export const GetHours = (
  startTime = dayjs().hour(8).minute(0).second(0),
  endTime = dayjs().hour(22).minute(0).second(0),
) => {
  const timeList = [];

  let currentTime = startTime;
  while (currentTime.isSameOrBefore(endTime)) {
    timeList.push(currentTime.format("h:mm A"));
    currentTime = currentTime.add(1, "hour");
  }
  return timeList;
};

export const GetMonths = () => {
  const date = new Date();
  return [
    `01/${date.getFullYear()}`,
    `02/${date.getFullYear()}`,
    `03/${date.getFullYear()}`,
    `04/${date.getFullYear()}`,
    `05/${date.getFullYear()}`,
    `06/${date.getFullYear()}`,
    `07/${date.getFullYear()}`,
    `08/${date.getFullYear()}`,
    `09/${date.getFullYear()}`,
    `10/${date.getFullYear()}`,
    `11/${date.getFullYear()}`,
    `12/${date.getFullYear()}`,
  ];
};

export const getDaysByMonth = (month) => {
  const daysInMonth = dayjs(month, "YYYY/MM").daysInMonth();
  return Array.from({ length: daysInMonth }, (v, k) => k + 1);
};

export const getCurrentWeek = () => {
  const today = dayjs();
  const startOfWeek = today.startOf("week");
  const endOfWeek = today.endOf("week");

  const weekDays = [];
  let currentDay = startOfWeek;

  while (currentDay.isSameOrBefore(endOfWeek, "day")) {
    weekDays.push(currentDay.format("MMM DD"));
    currentDay = currentDay.add(1, "day");
  }

  return weekDays;
};

export const GetDueDate = (date) => {
  return `${dayjs(date, "mm/DD/yyyy").format("DD")}/${dayjs().format(
    "MM/yyyy",
  )}`;
};
